// @core/api/endpoints/secret/unmount_engine.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/secret';

/**
 * Unmount secrets engine
 * Unmounts a secrets engine and permanently destroys all its data (secrets, keys, certificates). This operation is irreversible.
 */
export async function UnmountEngine(
  engine_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
